import { render, staticRenderFns } from "./StatisticS3TransferOutS3TopCostByMonth.vue?vue&type=template&id=004cca6e&"
import script from "./StatisticS3TransferOutS3TopCostByMonth.vue?vue&type=script&lang=js&"
export * from "./StatisticS3TransferOutS3TopCostByMonth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports